import { surveyLocalization } from "survey-core";

export var catalanSurveyStrings = {
  pagePrevText: "Anterior",
  pageNextText: "Següent",
  completeText: "Complet",
  otherItemText: "Un altre (descrigui)",
  progressText: "Pàgina {0} de {1}",
  emptySurvey: "No hi ha cap pàgina visible o pregunta a l'enquesta.",
  completingSurvey: "Gràcies per completar l'enquesta!",
  loadingSurvey: "L'enquesta s'està carregant ...",
  optionsCaption: "Selecciona ...",
  requiredError: "Si us plau contesti la pregunta.",
  requiredInAllRowsError: "Si us plau contesti les preguntes de cada filera.",
  numericError: "L'estimació ha de ser numèrica.",
  textMinLength: "Si us plau entre almenys {0} símbols.",
  textMaxLength: "Si us plau entre menys de {0} símbols.",
  textMinMaxLength: "Si us plau entre més de {0} i menys de {1} símbols.",
  minRowCountError: "Si us plau ompli almenys {0} fileres.",
  minSelectError: "Si us plau seleccioni almenys {0} variants.",
  maxSelectError: "Si us plau seleccioni no més de {0} variants.",
  numericMinMax: "El '{0}' deu ser igual o més de {1} i igual o menys de {2}",
  numericMin: "El '{0}' ha de ser igual o més de {1}",
  numericMax: "El '{0}' ha de ser igual o menys de {1}",
  invalidEmail: "Si us plau afegiu un correu electrònic vàlid.",
  urlRequestError: "La sol·licitud va tornar error '{0}'. {1}",
  urlGetChoicesError:
    "La sol·licitud va tornar buida de dates o la propietat 'trajectòria' no és correcta",
  exceedMaxSize: "La mida de l'arxiu no pot excedir {0}.",
  otherRequiredError: "Si us plau afegiu l'altra estimació.",
  uploadingFile:
    "El seu arxiu s'està pujant. Si us plau esperi uns segons i intenteu-ho de nou.",
  addRow: "Afegiu una filera",
  removeRow: "Eliminar una filera",
  choices_firstItem: "primer article",
  choices_secondItem: "segon article",
  choices_thirdItem: "tercer article",
  matrix_column: "Columna",
  matrix_row: "Filera"
};

surveyLocalization.locales["ca"] = catalanSurveyStrings;
surveyLocalization.localeNames["ca"] = "català";
